module.exports = "/assets/data/4158751cfc4220a0e49a09dd916e655a-BD1.data.json";